<template>
    <div id="reCAPTCHAEle" />
</template>

<script>
    export default {
        name:"RecaptchaV2",
        data() {
            return {

            };
        },
        props: [
            "theme",
            "size",
            "language",
            "siteKey"
        ],
        methods: {
            callback(response) {
                this.$EventBus.emit("loadCallback", response);
            },
            expiredCallback() {
                this.$EventBus.emit("expiredCallback");
            },
            errorCallback() {
                this.$EventBus.emit("errorCallback");
            }
        },
        beforeMount(){
            var ele = document.getElementById("googleCaptchaScript");
            if (ele) ele.remove();
            const script = document.createElement("script");
            const src = "https://www.google.com/recaptcha/api.js";
            const lang = this.language ? `&hl=${this.language}` : "";

            script.setAttribute("id", "googleCaptchaScript");
            script.setAttribute("src", `${src}?render=explicit${lang}`);
            script.setAttribute("async", "");
            script.setAttribute("defer", "");

            script.onerror = () => {
                new Error("Failed to load script");
            };

            document.head.appendChild(script);
        },
        mounted(){
            document.getElementById("googleCaptchaScript").onload = () => {
                if (!window.grecaptcha) throw new Error("reCAPTCHA is not loaded");
                window.grecaptcha.ready(() => {
                    var widgetId = window.grecaptcha.render("reCAPTCHAEle", {
                        sitekey: this.siteKey,
                        theme: this.theme ? this.theme : "light",
                        size: this.size ? this.size : "normal",
                        tabindex: 0,
                        callback: (response) => this.callback(response),
                        "expired-callback": () => this.expiredCallback(),
                        "error-callback": () => this.errorCallback(),
                    });

                    this.$EventBus.emit("widgetId", widgetId);
                });
            }
        },
    };
</script>